import {FC} from 'react'
import {useAppSelector} from '../../../../hooks/redux'
import {usersAPI} from '../../../../services/UsersService'
import {formatPeriod} from '../../helpers/period'

type Props = {
  data: string
}

const CSRItemDate: FC<Props> = ({data}) => {
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const query = useAppSelector((state) => state.csrFilter)
  const label = new Intl.DateTimeFormat(currentUser?.language, {weekday: 'short'}).format(new Date(data))
  const labelFull = new Intl.DateTimeFormat(currentUser?.language, {weekday: 'short'}).format(new Date(data))
  const dayMonth = new Intl.DateTimeFormat(currentUser?.language, {
    day: 'numeric',
    month: 'long',
  }).format(new Date(data))

  return (
    <div className='d-flex align-items-center'>
      {query.group_by === 'day' && (
        <>
          {label === 'сб' || label === 'вс' ? (
            <div className='text-danger'>
              {dayMonth}, {labelFull}
            </div>
          ) : (
            <div>
              {dayMonth}, {labelFull}
            </div>
          )}
        </>
      )}
      {query.group_by === 'week' && (
        <>{formatPeriod(data, query.group_by, currentUser?.language, currentUser?.time_zone)}</>
      )}
      {query.group_by === 'month' && (
        <>{formatPeriod(data, query.group_by, currentUser?.language, currentUser?.time_zone)}</>
      )}
    </div>
  )
}

export {CSRItemDate}
